<template>
	<!--<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>-->
	<select v-model="selected" class="select2-enable" :id='`species_${line_count}`'>
	    <optgroup v-for="group in options" :label='group.text' :key='group.text'>
	      <option v-for="option in group.children" :value="option.id" :key='option.id'>
	        {{ option.name }}
	      </option>
	    </optgroup>
	 </select>
</template>

<script>
	import {DB} from './../../../constants'
	import $ from 'jquery'
	import 'select2'
	import 'select2/dist/css/select2.css'
	const SPECIES = 'get_species.php'
	const ACT_LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'species',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: '',
			sp_id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`species`, {index: this.line_count, value: this.selected})
			}
		},
		mounted: function () {
			let region_id = this.$parent.f_12
			
			fetch(DB + SPECIES + `?region_id=${region_id}`, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					//console.warn(this.sp_id)
					this.options = [...data]; 
					this.selected = this.sp_id ?  this.sp_id : ''
				}
				else {
					this.options = []
				}

				return {id: this.selected, text: this.options[1].children.find(e => {
					return e.id == this.selected
				})}
			})
			.then(data => {
				if (data.id) {
					data.text = data.text.name
		            if ($('#species_' + this.$props.line_count).find("option[value='" + data.id + "']").length) {
		              $('#species_' + this.$props.line_count).val(data.id).trigger('change');
		            } else { 
		              const newOption = new Option(data.text, data.id, true, true)
		              $('#species_' + this.$props.line_count).append(newOption).trigger('change');
		            }
		          }
			})
			.catch(err => console.log(err))

			$(this.$el).ready(() => {
		      $('#species_' + this.$props.line_count).select2({})
		      $('#species_' + this.$props.line_count).on('change', (e) => {
		        this.$emit('input', e.target.value)
		      })
		    })

		    this.$on('input', id => {
		    	EventBus.$emit(`species`, {index: this.$props.line_count, value: id})
		    })
		}
	}
</script>

<style>
.select2-container {
  width: 100% !important;
  height: 24px !important;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	line-height: 24px;
}

.select2-container .select2-selection--single {
	height: 24px !important;
}

ul.select2-results__options {
  max-height: unset !important;
  font-size: 12px;
}

.select2-container--default .select2-results > .select2-results__options {
	max-height: 400px !important;
}

li.select2-results__option {
  display: block;
}

.select2-selection__rendered {
	text-align: left !important;
}

.select2-container--default,
.select2-container--default .select2-selection--single {
  border: none !important;
  height: 24px;
}

.select2-dropdown {
	width: 200px !important;
}
</style>


// WEBPACK FOOTER //
// species.vue?34474d5c